<template>
  <FinderRichText
    v-if="options.title"
    class="sp-finder-result-scheduling-message__title"
    role="heading"
    aria-level="3"
    :html="options.title"
  />
  <sp-icon v-if="options.icon" class="sp-finder-result-scheduling-message__icon" :name="options.icon"></sp-icon>
  <FinderRichText v-if="options.message" class="sp-finder-result-scheduling-message__heading" :html="options.message" />
  <sp-button
    v-if="options.url"
    class="sp-finder-result-scheduling-message__button"
    tag="a"
    :href="options.url"
    :target="target"
    >{{ options.label }}</sp-button
  >
  <FinderRichText
    v-if="options.booking_number_message"
    class="sp-finder-result-scheduling-message__booking-number"
    :html="options.booking_number_message"
  />
</template>

<script setup>
import { computed } from "vue";
import FinderRichText from "./FinderRichText.ce.vue";

const props = defineProps({
  /**
   * One scheduling message: `title`, `icon`, `message`, `url`, `label` and `booking_number_message`.
   *
   * @type {Object}
   */
  options: {
    type: Object,
    default: () => ({}),
  },
});

const target = computed(() => (/^https?:\/\//.test(props.options.url) ? "_blank" : undefined));
</script>

<style lang="scss" scoped>
.sp-finder-result-scheduling-message {
  &__title,
  &__heading {
    font: var(--sp-comp-finder-result-scheduling-heading-font, var(--sp-sys-typescale-h4-short));

    &.sp-finder-rich-text :deep(a) {
      font: inherit;
    }
  }

  &__title {
    margin-block: var(--sp-comp-finder-result-scheduling-message-title-margin-block, 1em);
  }

  &__title,
  &__heading,
  &__booking-number {
    :deep(p) {
      margin: 0;
    }
  }

  &__button {
    --sp-comp-button-width: 100%;

    display: block;
  }

  &__booking-number {
    font: var(--sp-comp-finder-result-scheduling-booking-number-font, var(--sp-sys-typescale-body-short));
  }
}
</style>
